import { Component } from '@angular/core';

@Component({
  selector: 'admin-input-group-demo',
  templateUrl: './input-group-demo.component.html',
  styleUrls: ['./input-group-demo.component.scss'],
})
export class InputGroupDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/form/control/input-group/input-group-demo.component.ts